import { render, staticRenderFns } from "./Compras.vue?vue&type=template&id=1864064d&scoped=true&"
import script from "./Compras.vue?vue&type=script&lang=js&"
export * from "./Compras.vue?vue&type=script&lang=js&"
import style0 from "./Compras.scss?vue&type=style&index=0&id=1864064d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1864064d",
  null
  
)

export default component.exports